export default __webpack_public_path__ + "static/gesture-swipe-left-b909f91224843ccce8436707b187fd27.gif";